import SAApi from './_saApi';
import httpClient from '@/apis/base/httpclient';

class SASaleInvoiceAPI extends SAApi {
  constructor() {
    super();
  }
  controllerName = 'SASaleInvoices';

  /**
   * Hàm get dữ liệu hóa đơn thay thế chưa được phát hành hoặc hóa đơn hủy đang lập
   * @param {*} payload
   * @returns
   * dqvinh 26.9.2022
   */
  async getDataSaleInvoiceDeleteOrUnPublished(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getDataSaleInvoiceDeleteOrUnPublished',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm get tổng bản ghi thay thế chưa được phát hành hoặc hóa đơn hủy đang lập
   * @param {*} payload
   * @returns
   * dqvinh 26.9.2022
   */
  async getSummarySaleInvoiceDeleteOrUnPublished(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getSummarySaleInvoiceDeleteOrUnPublished',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm get tổng bản ghi hóa đơn thay thế chưa được phát hành hoặc hóa đơn hủy đang lập
   * @returns
   * dqvinh 26.9.2022
   */
  async getSumaryDataSaleInvoiceDeleteOrUnPublished() {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getSumaryDataSaleInvoiceDeleteOrUnPublished',
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm get dữ liệu chứng từ bán hàng
   * @param {*} payload
   * @returns
   * NNLINH 08.09.2022
   */
  async getDataSaleVoucher(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getDataSaleVoucher',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm get dữ liệu detail chứng từ bán hàng
   * @param {*} payload
   * @returns
   * NNLINH 09.09.2022
   */
  async getDataSaleVoucherDetail(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getDataSaleVoucherDetail',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm get dữ liệu hóa đơn cho form hủy
   * @param {*} payload
   * @returns
   * TTLONG 20.09.2022
   */
  async getInvoiceForCancel(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getInvoiceForCancel',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Kiểm tra hóa đơn đã được lập hóa đơn điều chỉnh chưa
   * @param {*} payload
   * @returns
   * TTLONG 03.10.2022
   */
  async checkExistsAdjustmentInvoice(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/CheckExistsAdjustmentInvoice?refId=${payload}`,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Hàm lấy tài khoản chi tiết nhất
   * @param {*} payload
   * @returns
   */
  async getChildAccount(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getChildAccount',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm lấy dữ liệu mapping hóa đơn khi sinh chứng từ
   * @param {*} payload
   * @returns
   * NNLINH 19.09.2022
   */
  async getDataInvoiceMapping(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getDataInvoiceMapping',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm lấy dữ liệu mapping hóa đơn khi sinh chứng từ với mỗi hóa đơn là 1 chứng từ
   * @param {*} payload
   * @returns
   * NHANH3 22.05.204
   */
  async getDataInvoiceMappingMulti(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getDataInvoiceMappingMulti',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm cất nhiều chứng từ bán hàng
   * @param {*} payload 
   * @returns 
   * NHANH3 23.05.2024
   */
  async saveMultiSaleVoucher(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/saveMultiSaleVoucher',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy ra danh sách chứng từ
   * @param {*} payload
   * @returns
   */
  async getDataVoucher(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getDataVoucher',
      data: payload,
    };

    return await httpClient.getAsync(request);
  }

  /* Hàm lấy dữ liệu mapping hóa đơn khi sinh chứng từ
   * @param {*} payload
   * @returns
   * NNLINH 20.09.2022
   */
  async checkDataReference(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/checkDataReference',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }
  /**
   * Cập nhật dữ liệu hủy hóa đơn
   * @param {*} payload
   * @returns
   * TTLONG 23/09/2022
   */
  async updateCancelData(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/UpdateCancelData',
      data: payload,
    };

    return await httpClient.putAsync(request);
  }

  /**
   * Láy dữ liệu hóa đơn thay thế
   * @param {*} payload
   * @returns
   * TTLONG 28/09/2022
   */
  async getReplacementInvoice(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/GetReplacementInvoice?refId=${payload}`,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Hàm lấy danh sách hóa đơn đã phát hành
   * @param {*} payload
   * @returns
   * vqphong - 27/09/2022
   * ! Đây là tạm thời, sẽ xóa trong thời gian tới
   */
  async getPagingReleasedInvoice(payload) {
    let request = {
      url: this.getAPIUrl() + '/GetReleased',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
}

export default new SASaleInvoiceAPI();
